import TrialDecorationLayout from '@/features/agent/trial/layouts/TrialDecorationLayout';
import TrialTutorialTemplate from '@/features/agent/trial/templates/TrialTutorialTemplate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/trial/tutorial/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <TrialDecorationLayout>
      <TrialTutorialTemplate />
    </TrialDecorationLayout>
  );
}
